<div class="container-fluid">
    <div class="row mt-4">
        <div class="col-6">
            <a routerLink="/{{lang}}/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class=""><img class="img-responsive" src="./assets/logo_museo.svg" alt="Museo Logo" /></a>
        </div>
        <div class="col-6 text-right mt-4 pt-2">
            <img class="img-responsive mt-4 pt-4" src="./assets/comune.svg" alt="Comune">
        </div>
    </div>
</div>